import { Controller } from "@hotwired/stimulus"

/*
This controller scrolls to the top of the page after click. 
*/

export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:click', this.scroll)
  }

  disconnect() {
    this.element.removeEventListener('turbo:click', this.scroll)
  }

  scroll(event) {
    event.preventDefault()

    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
  }
}
